(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pathosion-ai-consult-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = `pathosion-ai-consult-popup-dismissed:${window.location.pathname}`;

    const wasDismissed = () => {
      try {
        return window.sessionStorage.getItem(storageKey) === 'true';
      } catch (_error) {
        return false;
      }
    };

    const rememberDismissal = () => {
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (_error) {
        // Storage can be unavailable in privacy-restricted browsers.
      }
    };

    const initializePopup = (popup) => {
      if (popup.dataset.initialized === 'true' || wasDismissed()) return;

      const article = popup.closest('.pathosion-article');
      const content = article?.querySelector('#article-content, .article-template__content');
      const popular = popup.closest('.pathosion-popular-articles');
      const close = popup.querySelector('[data-pathosion-ai-consult-popup-close]');
      const desktop = window.matchMedia('(min-width: 1200px)');
      let frame = 0;
      let hasBeenRevealed = false;

      if (!article || !content || !popular || !close) return;

      popup.dataset.initialized = 'true';

      const fitStickyRail = () => {
        if (!desktop.matches) {
          popular.style.removeProperty('--pathosion-popular-sticky-top');
          popular.classList.remove('is-viewport-constrained');
          return;
        }

        const edgeSpace = 20;
        const preferredTop = 100;
        const railHeight = popular.scrollHeight;
        const availableTop = window.innerHeight - railHeight - edgeSpace;
        const stickyTop = Math.max(edgeSpace, Math.min(preferredTop, availableTop));

        popular.style.setProperty('--pathosion-popular-sticky-top', `${stickyTop}px`);
        popular.classList.toggle('is-viewport-constrained', railHeight > window.innerHeight - edgeSpace * 2);
      };

      const showPopup = () => {
        if (hasBeenRevealed || wasDismissed()) return;

        hasBeenRevealed = true;
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        window.requestAnimationFrame(fitStickyRail);
      };

      const reveal = () => {
        if (wasDismissed()) return;

        if (!desktop.matches) {
          showPopup();
          return;
        }

        const contentTop = content.getBoundingClientRect().top;
        if (contentTop <= Math.max(100, window.innerHeight * 0.48)) showPopup();
      };

      const requestReveal = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = 0;
          reveal();
          if (hasBeenRevealed) fitStickyRail();
        });
      };

      close.addEventListener('click', () => {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        rememberDismissal();
        window.removeEventListener('scroll', requestReveal);
        window.removeEventListener('resize', requestReveal);
        window.setTimeout(fitStickyRail, 400);
      });

      window.addEventListener('scroll', requestReveal, { passive: true });
      window.addEventListener('resize', requestReveal, { passive: true });
      reveal();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-pathosion-ai-consult-popup]').forEach(initializePopup);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pathosion-popular-articles"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePopularRail = (popular) => {
      if (popular.dataset.railInitialized === 'true') return;

      const popularSticky = popular.querySelector('.pathosion-popular-articles__sticky');
      const layout = popular.closest('.pathosion-article-layout--with-sidebar');
      const desktop = window.matchMedia('(min-width: 1200px)');
      let updateFrame = 0;
      let popularStartY = 0;

      if (!popularSticky || !layout) return;

      popular.dataset.railInitialized = 'true';

      const clearFixedState = () => {
        popularSticky.classList.remove('is-viewport-fixed');
        popularSticky.style.removeProperty('--pathosion-popular-fixed-top');
        popularSticky.style.removeProperty('--pathosion-popular-fixed-left');
        popularSticky.style.removeProperty('--pathosion-popular-fixed-width');
      };

      const measureStart = () => {
        clearFixedState();
        popularStartY = window.scrollY + popular.getBoundingClientRect().top;
      };

      const updatePosition = () => {
        if (!desktop.matches || window.scrollY < popularStartY - 102) {
          clearFixedState();
          return;
        }

        const layoutRect = layout.getBoundingClientRect();
        const fixedTop = Math.min(102, layoutRect.bottom - popularSticky.offsetHeight);

        if (fixedTop <= -popularSticky.offsetHeight) {
          clearFixedState();
          return;
        }

        popularSticky.style.setProperty('--pathosion-popular-fixed-top', `${fixedTop}px`);
        popularSticky.style.setProperty('--pathosion-popular-fixed-left', `${layoutRect.left}px`);
        popularSticky.style.setProperty('--pathosion-popular-fixed-width', `${popular.getBoundingClientRect().width}px`);
        popularSticky.classList.add('is-viewport-fixed');
      };

      const requestUpdate = () => {
        if (updateFrame) return;
        updateFrame = window.requestAnimationFrame(() => {
          updateFrame = 0;
          updatePosition();
        });
      };

      const resetPosition = () => {
        measureStart();
        updatePosition();
      };

      const cleanup = (event) => {
        if (event.detail?.sectionId !== popular.dataset.sectionId) return;

        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', resetPosition);
        document.removeEventListener('shopify:section:unload', cleanup);
        if (updateFrame) window.cancelAnimationFrame(updateFrame);
        clearFixedState();
      };

      measureStart();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', resetPosition, { passive: true });
      document.addEventListener('shopify:section:unload', cleanup);
      updatePosition();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-pathosion-popular-articles]').forEach(initializePopularRail);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pathosion-sidebar-ctas"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCtas = (ctas) => {
      if (ctas.dataset.initialized === 'true') return;

      const article = ctas.closest('.pathosion-article');
      const content = article?.querySelector('#article-content, .article-template__content');
      const popular = ctas.closest('.pathosion-popular-articles');
      const desktop = window.matchMedia('(min-width: 1200px)');
      const minimumReadableScale = 0.82;
      let revealFrame = 0;
      let alignmentFrame = 0;
      let revealed = false;

      if (!article || !content || !popular) return;

      ctas.dataset.initialized = 'true';
      ctas.dataset.section = ctas.dataset.sectionId;

      // Escape article media stacking contexts so the fixed CTA always stays
      // above article images and embeds while retaining the captured anchors.
      document.body.appendChild(ctas);

      const scaleToRightEdge = () => {
        if (!desktop.matches) {
          ctas.classList.remove('is-visible');
          ctas.setAttribute('aria-hidden', 'true');
          revealed = false;
          return false;
        }

        const ctaLeft = Number.parseFloat(window.getComputedStyle(ctas).left) || 0;
        const targetRight = popular.getBoundingClientRect().right;
        const designWidth = ctas.offsetWidth;
        const availableWidth = Math.max(1, targetRight - ctaLeft);
        const scale = Math.min(1, availableWidth / designWidth);

        if (scale < minimumReadableScale) {
          ctas.classList.remove('is-visible');
          ctas.setAttribute('aria-hidden', 'true');
          revealed = false;
          return false;
        }

        ctas.style.setProperty('--pathosion-sidebar-popup-scale', `${scale}`);
        return true;
      };

      const reveal = () => {
        if (revealed || !scaleToRightEdge()) return;

        if (content.getBoundingClientRect().top <= Math.max(100, window.innerHeight * 0.48)) {
          revealed = true;
          ctas.classList.add('is-visible');
          ctas.setAttribute('aria-hidden', 'false');
          window.removeEventListener('scroll', requestReveal);
        }
      };

      const requestReveal = () => {
        if (revealFrame) return;
        revealFrame = window.requestAnimationFrame(() => {
          revealFrame = 0;
          reveal();
        });
      };

      const requestAlignment = () => {
        if (alignmentFrame) return;
        alignmentFrame = window.requestAnimationFrame(() => {
          alignmentFrame = 0;
          scaleToRightEdge();
          reveal();
        });
      };

      const cleanup = (event) => {
        if (event.detail?.sectionId !== ctas.dataset.sectionId) return;

        window.removeEventListener('scroll', requestReveal);
        window.removeEventListener('resize', requestAlignment);
        document.removeEventListener('shopify:section:unload', cleanup);
        if (revealFrame) window.cancelAnimationFrame(revealFrame);
        if (alignmentFrame) window.cancelAnimationFrame(alignmentFrame);
        ctas.remove();
      };

      window.addEventListener('scroll', requestReveal, { passive: true });
      window.addEventListener('resize', requestAlignment, { passive: true });
      document.addEventListener('shopify:section:unload', cleanup);
      scaleToRightEdge();
      reveal();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-pathosion-sidebar-ctas]').forEach(initializeCtas);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
